/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom";
import bgImage from "../../../assets/images/img-bg-full-apply.jpg";
import { Blank, EvButton, Font, Form, Input, Row } from "../../../styles/commonStyle";
import { modalGreyBtnColor, noticeRedColor } from "../../../styles/theme";
import { ContentBox, Layout } from "../style";
import TenantHeader from "./header";
import { findChargerQrTenantSelector } from "../../../recoil/variableAtom";
import { useEffect, useState } from "react";
import { RESULT, ResponseModel } from "../../../model/response";
import useFetch from "../../../hooks/useFetch";
import Loading from "../../../components/loading/loading";

function QRTenantEntryPage() {
  const { tenantCode } = useParams();
  let navigate = useNavigate();
  let [isSearchChager, setIsSearchChager] = useState(true);
  const [getQuery, setQuery] = useState<any>();
  const [isLoading, setLoading] = useState(false);
  const response: ResponseModel<any> = useFetch({
    recoilSelector: findChargerQrTenantSelector,
    query: getQuery,
  });

  useEffect(() => {
    if (!getQuery) {
      return;
    }
    if (response?.result === RESULT.OK) {
      setIsSearchChager(true);
      navigate(`/QRtenant/${tenantCode}/${getQuery.qrcode}`);
    }
    if (response?.result === RESULT.FAIL) {
      setIsSearchChager(false);
    }
  }, [response]);

  const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let qrcode = event.currentTarget.qrcode.value;
    setQuery({
      tenantCode: tenantCode,
      qrcode: qrcode,
    });
  };

  return (
    <div>
      <TenantHeader />
      <Form onSubmit={(e) => onSubmitHandler(e)}>
        <Layout image={bgImage} paddingTop="0.5rem">
          <ContentBox paddingLeft="1.5rem" paddingRight="1.5rem">
            <Font fontSize="1.25rem" fontWeight="600">
              비회원 QR 결제
            </Font>
            <Blank height="1.5rem"></Blank>
            <Row className="w-full">
              <Input placeholder="충전기에 부착된 QR번호를 입력해주세요" name="qrcode"></Input>
              <EvButton bgColor={modalGreyBtnColor} color="#fff" noRadius={true} width="7rem" type="submit">
                검색
              </EvButton>
            </Row>
            {!isSearchChager && (
              <Font color={noticeRedColor} fontSize="0.9rem" className="w-full mt-[0.5rem]" fontWeight="500">
                유효하지 않은 큐알코드/충전기 입니다.
              </Font>
            )}
            <Font fontSize="calc(0.6rem + 0.2vw)" color={modalGreyBtnColor} className="w-full mt-[0.5rem]" fontWeight="500">
              큐알코드 번호는 충전기에서 확인할 수 있습니다.
            </Font>
            <Loading isLoading={isLoading} />
          </ContentBox>
        </Layout>
      </Form>
    </div>
  );
}

export default QRTenantEntryPage;
